import React, { PureComponent } from "react";
import Input from "@components/Input";
import Playlist from "@components/Playlist";
import Service from "@base/service";

import "./Home.less";

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      radio: null,
      playAoVivo: false,
      searching: false,
      query: "",
    };
    this.search = this.search.bind(this);
    this.service = new Service();
  }

  render() {
    const quantidadeVideos = 10; // mais recentes por playlist
    if (!this.state.radio) return null;
    return (
      <div className="Home-page">
        <main>
          {this.renderAoVivo()}
          <form onSubmit={this.search}>
            <div id="form-search">
              {this.state.searching ? (
                "Buscando..."
              ) : (
                <>
                  <Input
                    className="search"
                    placeholder="Buscar vídeos"
                    value={this.state.query}
                    onChange={(event) =>
                      this.setState({ query: event.target.value })
                    }
                  />
                  {this.state.query.length > 1 && (
                    <button
                      type="button"
                      onClick={() => this.setState({ query: "" }, this.search)}
                    >
                      LIMPAR
                    </button>
                  )}
                  <button type="submit">OK</button>
                </>
              )}
            </div>
          </form>
          {this.state.radio.playlists?.map((playlist) => (
            <Playlist
              key={playlist.id}
              scroll={true}
              id={playlist.id}
              titulo={playlist.title}
              videos={playlist.videos.slice(0, quantidadeVideos)}
            />
          ))}
        </main>
      </div>
    );
  }

  search(event) {
    if (event) {
      event.preventDefault();
    }
    this.setState({ searching: true }, async () => {
      this.setState({
        radio: await this.service.getRadio(this.state.query),
        searching: false,
      });
    });
  }

  renderAoVivo() {
    if (!this.state.radio.ao_vivo || !this.state.radio.ao_vivo.status)
      return null;
    return (
      <div className="ao-vivo">
        {this.state.playAoVivo ? (
          <>
            <div
              className="botao"
              onClick={() => this.setState({ playAoVivo: false })}
            >
              <button type="button">‹ Voltar</button>
            </div>
            <iframe
              title={this.state.radio.ao_vivo.title}
              src={this.state.radio.ao_vivo.iframe_url}
              frameBorder="0"
              scrolling="no"
              allowFullScreen
            />
          </>
        ) : (
          <div
            className="play-ao-vivo"
            onClick={() => this.setState({ playAoVivo: true })}
          >
            <div>
              <p>{this.state.radio.ao_vivo.title}</p>
              <button type="button">Assistir</button>
            </div>
          </div>
        )}
        <div className="info">
          <div
            className="descricao"
            dangerouslySetInnerHTML={{
              __html: this.state.radio.ao_vivo.description,
            }}
          />
        </div>
      </div>
    );
  }

  async componentDidMount() {
    this.setState({ radio: await this.service.getRadio() });
  }
}

export default Home;
